import React, { useState, useRef } from "react";
import { FiEdit, FiTrash, FiPlus } from "react-icons/fi";
import { toast } from "react-toastify";
import { CiEdit } from "react-icons/ci";
import { MdDeleteSweep, MdDownloadDone } from "react-icons/md";
import { IoIosAddCircleOutline } from "react-icons/io";
import { updateCustomerJourney } from "../../services/userCustomerJourney";
import { useFetchAllIndustriesList } from "../../hooks/useIndustry";
import Swal from 'sweetalert2';


function convertTouchpointFormat(touchpointCJBP) {
    // Get the unique steps from the input
    const steps = [...new Set(touchpointCJBP.touchpoints.map(tp => tp.step))];
    if (Array.isArray(steps)) {
        const convertedData = steps.map(step => {
            // Filter the touchpoints for the current step
            const touchpointsForStep = touchpointCJBP.touchpoints.filter(tp => tp.step === step);

            // Construct the object for this step
            return {
                step: step,
                title: touchpointsForStep[0]?.title || step,
                touchpoints: touchpointsForStep.map(tp => ({
                    x: tp.x,
                    y: tp.y,
                    id: tp.id,
                    step: tp.step,
                    title: tp.title,
                    labelTop: tp.labelTop,
                    labelBottom: tp.labelBottom,
                }))
            };
        });
        return convertedData;

    }
    // Map each step to its new structure


}
function convertArTouchpointFormat(touchpointArCJBP) {
    // Get the unique steps from the input
    const arSteps = touchpointArCJBP?.arTouchpoints
    ? [...new Set(touchpointArCJBP.arTouchpoints.map(tp => tp.arStep))]
    : [];
  
    if (Array.isArray(arSteps)) {
        const convertedData = arSteps.map(arStep => {
            // Filter the touchpoints for the current step
            const touchpointsForArStep = touchpointArCJBP.arTouchpoints.filter(tp => tp.arStep === arStep);

            // Construct the object for this step
            return {
                arStep: arStep,
                arabicTitle: touchpointsForArStep[0]?.arabicTitle || arStep,
                arTouchpoints: touchpointsForArStep.map(tp => ({
                    x: tp.x,
                    y: tp.y,
                    id: tp.id,
                    arStep: tp.arStep,
                    arabicTitle: tp.arabicTitle,
                    arabicLabelTop: tp.arabicLabelTop,
                    arabicLabelBottom: tp.arabicLabelBottom,
                }))
            };
        });
        return convertedData;

    }
    // Map each step to its new structure


}

const UpdateJourney = ({ toggleModal, handleClose, selectedCustomer }) => {
    const canvasRef = useRef(null); // Reference to canvas element
    const [industry, setIndustry] = useState(selectedCustomer.industry || "");
    const [name, setName] = useState(selectedCustomer.name || "");
    const [description, setDescription] = useState(selectedCustomer.description || "");
    const [steps, setSteps] = useState(convertTouchpointFormat(selectedCustomer.touchpointCJBP) || []);
    const [touchpoints, setTouchpoints] = useState((selectedCustomer.touchpointCJBP.touchpoints) || []);
    const [activeStepIndex, setActiveStepIndex] = useState(null);
    const [newLabelTop, setNewLabelTop] = useState("");
    const [newLabelBottom, setNewLabelBottom] = useState("");
    const [newTitle, setNewTitle] = useState("");
    const [stepName, setStepName] = useState("");
    const [title, setTitle] = useState("");
    const [updatedTitle, setUpdatedTitle] = useState("");
    const [updatedTopLabel, setUpdatedTopLabel] = useState("");
    const [updatedBottomLabel, setUpdatedBottomLabel] = useState("");
    const [editingTouchpointId, setEditingTouchpointId] = useState(null);
    const { data, error, isLoading } = useFetchAllIndustriesList();

    //arabic
    const [arabicNewLabelTop, setArabicNewLabelTop] = useState("");
    const [arabicNewLabelBottom, setArabicNewLabelBottom] = useState("");
    const [arabicNewTitle, setArabicNewTitle] = useState("");
    //arabic touchpoints,steps
    const [arSteps, setArSteps] = useState(convertArTouchpointFormat(selectedCustomer.touchpointArCJBP) || []);
    const [arTouchpoints, setArTouchpoints] = useState(
        selectedCustomer?.touchpointArCJBP?.arTouchpoints || []
      );
      
    const [activeArStepIndex, setActiveArStepIndex] = useState(null);

    const [arabicIndustry, setArabicIndustry] =useState(selectedCustomer.arabicIndustry || "");
    const [arabicName, setArabicName] =  useState(selectedCustomer.arabicName || "");
    const [arabicStepName, setArabicStepName] = useState("");
    const [arabicDescription, setArabicDescription] =  useState(selectedCustomer.arabicDescription || "");
    const [arabicTitle, setArabicTitle] = useState("");

    const [updatedArabicTitle, setUpdatedArabicTitle] = useState("");
    const [updatedArabicTopLabel, setUpdatedArabicTopLabel] = useState("");
    const [updatedArabicBottomLabel, setUpdatedArabicBottomLabel] = useState("");
    const [editingArTouchpointId, setEditingArTouchpointId] = useState(null);

    const columnWidth = 250;
    const canvasHeight = 500;

    const handleUpdateStep = (index, updatedStep) => {
        const updatedSteps = [...steps];
        updatedSteps[index] = updatedStep;
        setSteps(updatedSteps);
    };

    const handleAddTouchpoint = (stepIndex) => {
        if (!newTitle || !newLabelTop || !newLabelBottom || !arabicNewTitle || !arabicNewLabelTop || !arabicNewLabelBottom) {
            toast.info("Please fill in all fields");
            return;
        }

        const step = steps[stepIndex];
        const arStep = arSteps[stepIndex]
        const x = stepIndex * columnWidth + columnWidth / 2;
        const y = canvasHeight / 2 + 100 * Math.sin((x / 150) * 2 * 1.2);

        const newTouchpoint = {
            x,
            y,
            id: touchpoints.length + 1,
            step: step.step,
            title: newTitle || step.title,
            labelTop: newLabelTop,
            labelBottom: newLabelBottom
        };

        const newArTouchpoint = {
            x,
            y,
            id: arTouchpoints.length + 1,
            arStep: arStep.arStep,
            arabicTitle: arabicNewTitle || step.arabicTitle,
            arabicLabelTop: arabicNewLabelTop,
            arabicLabelBottom: arabicNewLabelBottom
        };


        setTouchpoints([...touchpoints, newTouchpoint]);
        setArTouchpoints([...arTouchpoints, newArTouchpoint]);

        const updatedSteps = [...steps];
        const updatedArSteps = [...arSteps];
        updatedSteps[stepIndex].touchpoints.push(newTouchpoint);
        updatedArSteps[stepIndex].arTouchpoints.push(newArTouchpoint);
        setSteps(updatedSteps);
        setArSteps(updatedArSteps);

        setNewLabelTop('');
        setNewLabelBottom('');
        setNewTitle('');
        setActiveStepIndex(null);
        setArabicNewLabelTop('');
        setArabicNewLabelBottom('');
        setArabicNewTitle('');
        setActiveArStepIndex(null);
    };


    const handleAddStep = () => {
        if (!stepName || !title || !arabicStepName || !arabicTitle ) {
            toast.info("Please fill in all fields");
            return;
        }
        const newStep = { step: stepName, title: title, touchpoints: [] };
        setSteps([...steps, newStep]);
        //ar
        const newArStep = { arStep: arabicStepName, arabicTitle: arabicTitle, arTouchpoints: [] };
        setArSteps([...arSteps, newArStep]);

        setArabicStepName('')
        setArabicTitle('')
        setStepName('')
        setTitle('')

    };
    const handleUpdateTouchpoint = (touchpointId, arTouchpointId) => {
        const touchpoint = touchpoints.find((tp) => tp.id === touchpointId);
        setUpdatedTitle(touchpoint.title);
        setUpdatedTopLabel(touchpoint.labelTop);
        setUpdatedBottomLabel(touchpoint.labelBottom);
        setEditingTouchpointId(touchpointId);

        //arabic 
        const arTouchpoint = arTouchpoints.find((tp) => tp.id === arTouchpointId);
        setUpdatedArabicTitle(arTouchpoint.arabicTitle);
        setUpdatedArabicTopLabel(arTouchpoint.arabicLabelTop);
        setUpdatedArabicBottomLabel(arTouchpoint.arabicLabelBottom);
        setEditingArTouchpointId(arTouchpointId);
    };


    const handleSaveUpdatedTouchpoint = () => {
        if (!updatedTitle || !updatedTopLabel || !updatedBottomLabel || !updatedArabicTitle || !updatedArabicTopLabel || !updatedArabicBottomLabel) {
            toast.info("Please fill in all fields");
            return;
        }

        const updatedTouchpoints = touchpoints.map((tp) =>
            tp.id === editingTouchpointId
                ? { ...tp, title: updatedTitle, labelTop: updatedTopLabel, labelBottom: updatedBottomLabel }
                : tp
        );

        setTouchpoints(updatedTouchpoints);

        const updatedSteps = steps.map((step) => {
            step.touchpoints = step.touchpoints.map((tp) =>
                tp.id === editingTouchpointId
                    ? { ...tp, title: updatedTitle, labelTop: updatedTopLabel, labelBottom: updatedBottomLabel }
                    : tp
            );
            return step;
        });
        setSteps(updatedSteps);


        //save arabic update tp 
        const updatedArTouchpoints = arTouchpoints.map((tp) =>
            tp.id === editingArTouchpointId
                ? { ...tp, arabicTitle: updatedArabicTitle, arabicLabelTop: updatedArabicTopLabel, arabicLabelBottom: updatedArabicBottomLabel }
                : tp
        );

        setArTouchpoints(updatedArTouchpoints);

        const updatedArSteps = arSteps.map((step) => {
            step.arTouchpoints = step.arTouchpoints.map((tp) =>
                tp.id === editingArTouchpointId
                    ? { ...tp, arabicTitle: updatedArabicTitle, arabicLabelTop: updatedArabicTopLabel, arabicLabelBottom: updatedArabicBottomLabel }
                    : tp
            );
            return step;
        });


        setArSteps(updatedArSteps);

        setUpdatedTitle("");
        setUpdatedTopLabel("");
        setUpdatedBottomLabel("");
        setUpdatedArabicTitle("");
        setUpdatedArabicTopLabel("");
        setUpdatedArabicBottomLabel("");
        setEditingTouchpointId(null);
        setEditingArTouchpointId(null);
    };

    const handleDeleteTouchpoint = (touchpointId, arTouchpointId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to undo this action!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    // Update touchpoints
                    const updatedTouchpoints = touchpoints.filter((tp) => tp.id !== touchpointId);
                    setTouchpoints(updatedTouchpoints);

                    // Update artouchpoints
                    const updatedArTouchpoints = arTouchpoints.filter((tp) => tp.id !== arTouchpointId);
                    setArTouchpoints(updatedArTouchpoints);

                    // Update steps
                    const updatedSteps = steps.map((step) => {
                        step.touchpoints = step.touchpoints.filter((tp) => tp.id !== touchpointId);
                        return step;
                    });
                    setSteps(updatedSteps);

                    // Update arSteps
                    const updatedArSteps = arSteps.map((step) => {
                        step.arTouchpoints = step.arTouchpoints.filter((tp) => tp.id !== arTouchpointId);
                        return step;
                    });
                    setArSteps(updatedArSteps);

                    // Show success message
                    Swal.fire({
                        title: "Deleted!",
                        text: "The touchpoint has been successfully removed.",
                        icon: "success"
                    });
                } catch (error) {
                    // Show error message
                    Swal.fire({
                        title: "Error!",
                        text: "An unexpected error occurred. Please try again later.",
                        icon: "error"
                    });
                    console.error("Error deleting touchpoint:", error);
                }
            }
        });
    };
    const handleStepClick = (stepIndex) => {
        setActiveStepIndex(stepIndex);
        setActiveArStepIndex(stepIndex);
    };
    const handleRemoveStep = (stepToRemove, arStepToRemove) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to undo this action!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, remove it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    // Remove the step
                    setSteps(steps.filter((step) => step !== stepToRemove));
                    setArSteps(arSteps.filter((arStep) => arStep !== arStepToRemove));

                    // Show success message
                    Swal.fire({
                        title: "Removed!",
                        text: "The customer journey has been successfully removed.",
                        icon: "success"
                    });
                } catch (error) {
                    // Show error message
                    Swal.fire({
                        title: "Error!",
                        text: "An unexpected error occurred. Please try again later.",
                        icon: "error"
                    });
                    console.error("Error removing customer journey:", error);
                }
            }
        });
    };

    const handleSubmit = () => {
        if (!industry) {
            return toast.info("Industry is required");
        }
        if (!name) {
            return toast.info("Name is required");
        }
        if (!description) {
            return toast.info("Description is required");
        }
        if (!arabicIndustry) {
            return toast.info("arabic Industry is required")
        }
        if (!arabicName) {
            return toast.info("arabic Name is required")
        }
        if (!arabicDescription) {
            return toast.info("arabic Description is required")
        }
         // Auto-add step if user filled inputs but didn't click "Add Step"
         if (stepName && title && arabicStepName && arabicTitle) {
            steps.push({ step: stepName, title, touchpoints: [] });
            arSteps.push({ arStep: arabicStepName, arabicTitle, arTouchpoints: [] });
    
            // Vider les champs
            setStepName('');
            setTitle('');
            setArabicStepName('');
            setArabicTitle('');
        }

        const journeyData = {
            industry,
            name,
            description,
            arabicIndustry,
            arabicName,
            arabicDescription,
            steps: steps.map((step) => step.step),
            touchpoints,
            arSteps: arSteps.map((arStep) => arStep.arStep),
            arTouchpoints,
        };
        console.log("journeyData-------------->", journeyData)

        updateCustomerJourney(selectedCustomer.id, journeyData)
            .then((data) => {
                toast.success("Customer journey updated successfully");
                handleClose();
            })
            .catch((error) => {
                toast.error("Failed to update customer journey");
                console.error("Failed to update customer journey:", error);
                toggleModal();
            });
    };

    return (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg p-6 w-1/2 max-h-[80vh] overflow-y-auto shadow-lg">
                <div className="flex justify-between">
                    <h2 className="text-2xl font-semibold mb-4">Update Journey</h2>
                    <h2
                        className="text-2xl font-semibold mb-4 cursor-pointer"
                        onClick={() => handleClose()}
                    >
                        X
                    </h2>
                </div>
                <form onSubmit={(e) => e.preventDefault()}>
                    {/* Industry Dropdown */}
                    <div className="grid grid-cols-2 gap-4 mb-4">
                        {/* English Industry Select */}
                        <div className="relative z-0 w-full mb-5 group">
                            <label className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"> </label>
                            <select

                                className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                onChange={(e) => setIndustry(e.target.value)}
                                value={industry}
                            >
                                <option value="">Select Industry</option>
                                {data.industry.map((ind) => (
                                    <option key={ind.name} value={ind.name}>
                                        {ind.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Arabic Industry Select */}
                        <div className="relative z-0 w-full mb-5 group" dir="rtl">
                            <label className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"> </label>

                            <select
                                className="block appearance-none w-full py-2.5 pr-10 pl-8 text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                onChange={(e) => setArabicIndustry(e.target.value)}
                                value={arabicIndustry}
                            >
                                <option value="">الصناعة</option>
                                {data.industryArabicName
                                    .filter((ind) => ind)
                                    .map((ind) => (
                                        <option key={ind.name} value={ind.name}>
                                            {ind.name}
                                        </option>
                                    ))}
                            </select>
                        </div>
                    </div>

                    {/* Name Input */}
                    <div className="grid grid-cols-2 gap-4 mb-4">
                        <div className="relative z-0 w-full mb-5 group">

                            <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder=" " className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" />
                            <label className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Enter name </label>
                        </div>
                        <div className="relative z-0 w-full mb-5 group" dir="rtl">
                            <input type="text" value={arabicName} onChange={(e) => setArabicName(e.target.value)} placeholder=" " className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" />
                            <label className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">أدخل الاسم</label>

                        </div>
                    </div>

                    {/* Description Input */}
                    <div className="grid grid-cols-2 gap-4 mb-4">
                        <div className="relative z-0 w-full mb-5 group">
                            <input type="text" value={description} onChange={(e) => setDescription(e.target.value)} placeholder="" className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" />
                            <label className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Enter description </label>

                        </div>
                        <div className="relative z-0 w-full mb-5 group" dir="rtl">
                            <input type="text" value={arabicDescription} onChange={(e) => setArabicDescription(e.target.value)} placeholder=" " className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" />
                            <label className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">أدخل الوصف</label>

                        </div>
                    </div>

                    {/* Steps and Touchpoints */}
                    {/* Add Custom Step */}
                    {/* Add Custom Step */}
                    <div className="grid grid-cols-2 gap-4 mb-4">
                        <div className="relative z-0 w-full mb-5 group">
                            <input type="text" value={stepName} onChange={(e) => setStepName(e.target.value)} placeholder=" " className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" />
                            <label className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Enter step name </label>

                        </div>
                        <div className="relative z-0 w-full mb-5 group" dir="rtl">
                            <input type="text" value={arabicStepName} onChange={(e) => setArabicStepName(e.target.value)} placeholder=" " className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" />
                            <label className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">أدخل اسم المرحلة</label>

                        </div>
                    </div>

                    <div className="flex items-center gap-4 mb-6">
                        {/* Champ de titre en anglais */}
                        <div className="relative z-0 w-full group">
                            <input
                                type="text"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                placeholder=" "
                                className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                            />
                            <label className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-0 -z-10 origin-[0] peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
                                Enter step title
                            </label>
                        </div>

                        {/* Bouton centré */}
                        <button
                            type="button"
                            onClick={handleAddStep}
                            className="text-green-600"
                            title="Ajouter une étape"
                        >
                            <IoIosAddCircleOutline className="w-6 h-6" />
                        </button>

                        {/* Champ de titre en arabe */}
                        <div className="relative z-0 w-full group" dir="rtl">
                            <input
                                type="text"
                                value={arabicTitle}
                                onChange={(e) => setArabicTitle(e.target.value)}
                                placeholder=" "
                                className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                            />
                            <label className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 right-0 -z-10 origin-[0] peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">
                                أدخل عنوان المرحلة
                            </label>
                        </div>
                    </div>




                    {/* Display Steps */}
                    <div className="grid grid-cols-2 gap-4 mb-6">
                        <div className="col-span-2">
                            <div className="grid grid-cols-3 gap-4">
                                <label className="text-left text-lg font-semibold">Steps</label>
                                <div></div> {/* Empty center cell */}
                                <label className="text-right text-lg font-semibold">المراحل</label>
                            </div>
                            <div className="mt-4">
                                {steps.map((step, index) => {
                                    const arStep = arSteps[index];
                                    return (
                                        <div key={step.id} className="mb-4 border-b pb-4">
                                            <div className="grid grid-cols-3 gap-4 items-center">
                                                <span className="text-gray-700 text-left">{step.title}</span>

                                                <div className="flex justify-center space-x-2">
                                                    <button
                                                        type="button"
                                                        onClick={() => handleRemoveStep(step, arStep)}

                                                    >
                                                        <MdDeleteSweep className="w-6 h-6 text-red-600" />
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={() => handleStepClick(index)}
                                                        className="flex items-center gap-2  hover:bg-green-600 text-green-800 hover:text-white font-medium py-2 px-4 border border-green-500 hover:border-green-600 rounded-full shadow-sm transition-all duration-200"
                                                    >
                                                        <IoIosAddCircleOutline className="w-5 h-5" />
                                                        Touchpoint
                                                    </button>

                                                </div>
                                                <span className="text-gray-700 text-right">{arStep?.arabicTitle}</span>
                                            </div>
                                            {/* Display Touchpoints */}
                                            <div className="ml-4">
                                                {step?.touchpoints?.map((tp, index) => {
                                                    const arTouchpoint = arStep?.arTouchpoints?.[index]
                                                    return (
                                                        <div key={tp.id} className="grid grid-cols-3 items-center m-2 gap-4">
                                                            <span className="text-left">{tp.title} </span>
                                                            <div className="flex justify-center space-x-2">
                                                                <button
                                                                    type="button"
                                                                    onClick={() => handleUpdateTouchpoint(tp.id, arTouchpoint.id)}

                                                                >
                                                                    <CiEdit className="w-6 h-6 text-green-600" />
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => handleDeleteTouchpoint(tp.id, arTouchpoint.id)}

                                                                >
                                                                    <MdDeleteSweep className="w-6 h-6 text-red-600" />
                                                                </button>
                                                            </div>
                                                            <span className="text-right">{arTouchpoint?.arabicTitle}</span>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>

                                    );
                                })}

                            </div>
                        </div>
                    </div>

                    {/* Add Touchpoint Form */}
                    {activeStepIndex !== null && (
                        <div className="mb-4 flex gap-4 items-start">
                            <div className="flex flex-col items-start space-y-4 w-1/3">
                                <input
                                    type="text"
                                    placeholder="Touchpoint Title"
                                    value={newTitle}
                                    onChange={(e) => setNewTitle(e.target.value)}
                                    className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                />
                                <input
                                    type="text"
                                    placeholder="Top Label"
                                    value={newLabelTop}
                                    onChange={(e) => setNewLabelTop(e.target.value)}
                                    className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                />
                                <input
                                    type="text"
                                    placeholder="Bottom Label"
                                    value={newLabelBottom}
                                    onChange={(e) => setNewLabelBottom(e.target.value)}
                                    className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                />
                            </div>

                            {/* Arabic Inputs */}
                            <div className="flex flex-col items-start space-y-4 w-1/3">
                                <input
                                    type="text"
                                    placeholder="عنوان نقطة التلامس"
                                    value={arabicNewTitle}
                                    onChange={(e) => setArabicNewTitle(e.target.value)}
                                    className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                />
                                <input
                                    type="text"
                                    placeholder="العنوان العلوي"
                                    value={arabicNewLabelTop}
                                    onChange={(e) => setArabicNewLabelTop(e.target.value)}
                                    className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                />
                                <input
                                    type="text"
                                    placeholder="العنوان السفلي"
                                    value={arabicNewLabelBottom}
                                    onChange={(e) => setArabicNewLabelBottom(e.target.value)}
                                    className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                />
                            </div>


                            <div className="flex flex-col justify-center items-center w-1/3 pt-4">
                                <button
                                    onClick={() => handleAddTouchpoint(activeStepIndex)}
                                    className="flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white font-semibold py-3 px-6 rounded-full transition-all duration-200"
                                >
                                    <MdDownloadDone />

                                </button>
                            </div>
                        </div>




                    )}

                    {/* Editing Touchpoint */}
                    {editingTouchpointId !== null && editingArTouchpointId !== null && (
                        <>
                            <div className="mb-4 flex gap-4 items-start">


                                <div className="flex flex-col items-start space-y-4 w-1/3">
                                    <h3 className="text-lg font-semibold mb-2">Edit Touchpoint</h3>
                                    <input
                                        type="text"
                                        placeholder="Touchpoint Title"
                                        value={updatedTitle}
                                        onChange={(e) => setUpdatedTitle(e.target.value)}
                                        className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                    />
                                    <input
                                        type="text"
                                        placeholder="Top Label"
                                        value={updatedTopLabel}
                                        onChange={(e) => setUpdatedTopLabel(e.target.value)}
                                        className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                    />
                                    <input
                                        type="text"
                                        placeholder="Bottom Label"
                                        value={updatedBottomLabel}
                                        onChange={(e) => setUpdatedBottomLabel(e.target.value)}
                                        className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                    />
                                </div>
                                <div className="flex flex-col items-start space-y-4 w-1/3">
                                    <h3 className="text-lg font-semibold mb-2">تعديل نقطة التلامس</h3>
                                    <input
                                        type="text"
                                        placeholder="عنوان نقطة التلامس"
                                        value={updatedArabicTitle}
                                        onChange={(e) => setUpdatedArabicTitle(e.target.value)}
                                        className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                    />
                                    <input
                                        type="text"
                                        placeholder="العنوان العلوي"
                                        value={updatedArabicTopLabel}
                                        onChange={(e) => setUpdatedArabicTopLabel(e.target.value)}
                                        className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                    />
                                    <input
                                        type="text"
                                        placeholder="العنوان السفلي"
                                        value={updatedArabicBottomLabel}
                                        onChange={(e) => setUpdatedArabicBottomLabel(e.target.value)}
                                        className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                                    />
                                </div>

                                <div className="flex flex-col justify-center items-center w-1/3 pt-4">
                                    <button
                                        type="button"
                                        onClick={handleSaveUpdatedTouchpoint}
                                        className="flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white font-semibold py-3 px-6 rounded-full transition-all duration-200"
                                    >
                                        <MdDownloadDone /><CiEdit />
                                    </button>
                                </div>

                            </div>
                        </>


                    )}
                </form>
                <button
                    onClick={handleSubmit}
                    className="bg-blue-500 text-white px-4 py-2 rounded-md mt-4"
                >
                    Save Changes
                </button>
            </div>
        </div>
    );
};

export default UpdateJourney;
